module.exports = __webpack_public_path__ + "static/media/028_concepts_nk_2-09.f37a1e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/028_concepts_nk_2-09.png
// module id = 526
// module chunks = 0